import AntIcon from "@/components/icons/AntIcon";
import { Button, Col, Popconfirm, Row, Upload } from "antd";
import { RcFile } from "antd/es/upload";
import { useTranslation } from "react-i18next";
import {
  useExportVehicleMappings,
  useImportVehicleMappings,
  useMapVehicleMappingsUpdates,
  useRemapVehicleMappings,
} from "../../../../common/api/queries";
import { FileUploadAccept, rowGutter } from "../../../../common/constants";
import { VehicleMappingType } from "../enums";

type Props = {
  selectedMappingTypes: VehicleMappingType[];
};

export const VehicleMappingActions = ({ selectedMappingTypes }: Props) => {
  const { t } = useTranslation();

  const remapVehicleMappings = useRemapVehicleMappings();
  const mapVehicleMappingsUpdates = useMapVehicleMappingsUpdates();
  const importVehicleMappings = useImportVehicleMappings();
  const exportVehicleMappings = useExportVehicleMappings();

  const isDisabled = selectedMappingTypes.length === 0;

  const handleImportMappingsClick = (file: RcFile) => {
    const formData = new FormData();
    formData.append("file", file);
    importVehicleMappings.mutate(formData);
    return false;
  };

  return (
    <Row gutter={[rowGutter, rowGutter]}>
      <Col xs={24} md={12}>
        <Popconfirm
          title={<p style={{ maxWidth: 350 }}>{t("vehicle.helpers.remapMappingsConfirm")}</p>}
          icon={<AntIcon type="question" />}
          okText={t("common.yes")}
          cancelText={t("common.no")}
          okType="primary"
          onConfirm={() => remapVehicleMappings.mutate({ queriedMappings: selectedMappingTypes })}
          disabled={isDisabled}
        >
          <Button style={{ width: "100%" }} icon={<AntIcon type="cloud-upload" />} disabled={isDisabled}>
            {t("vehicle.actions.remapMappings")}
          </Button>
        </Popconfirm>
      </Col>

      <Col xs={24} md={12}>
        <Popconfirm
          title={<p style={{ maxWidth: 350 }}>{t("vehicle.helpers.mapMappingsUpdatesConfirm")}</p>}
          icon={<AntIcon type="question" />}
          okText={t("common.yes")}
          cancelText={t("common.no")}
          okType="primary"
          onConfirm={() => mapVehicleMappingsUpdates.mutate({ queriedMappings: selectedMappingTypes })}
          disabled={isDisabled}
        >
          <Button style={{ width: "100%" }} icon={<AntIcon type="swap" />} disabled={isDisabled}>
            {t("vehicle.actions.mapMappingsUpdates")}
          </Button>
        </Popconfirm>
      </Col>

      <Col xs={24} md={12}>
        <Button
          style={{ width: "100%" }}
          icon={<AntIcon type="download" />}
          onClick={() => exportVehicleMappings.mutate()}
          disabled={isDisabled}
        >
          {t("vehicle.actions.exportMappings")}
        </Button>
      </Col>

      <Col xs={24} md={12}>
        <Upload
          style={{ width: "100%" }}
          beforeUpload={(file) => handleImportMappingsClick(file)}
          showUploadList={false}
          accept={FileUploadAccept.CSV}
          disabled={isDisabled}
        >
          <Button style={{ width: "100%" }} icon={<AntIcon type="import" />} disabled={isDisabled}>
            {t("vehicle.actions.importMappings")}
          </Button>
        </Upload>
      </Col>
    </Row>
  );
};
